import { getAccountStatusMeta } from '@/settings/components/connected-account-status-meta'
import { PROVIDER_META } from '@/user_files/external-storage/ProviderMeta'
import { ConnectedAccount } from '@/settings/schemas/external-storage-schema'

export function ConnectedDmsRow({ account }: { account: ConnectedAccount }) {
  const meta = PROVIDER_META[account.provider]
  const statusMeta = getAccountStatusMeta(account.status)

  return (
    <div className="flex items-center gap-4 px-4 py-4">
      <div className="flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-md border border-brand-neutral-200 bg-white">{meta.modalIcon}</div>
      <div className="min-w-0 flex-1">
        <p className="font-rethink-sans text-base font-semibold leading-7 tracking-normal text-brand-neutral-950">{meta.label}</p>
        {account.display_email && <p className="truncate text-sm leading-5 tracking-[-0.15px] text-brand-neutral-600">{account.display_email}</p>}
      </div>
      <span className="flex shrink-0 items-center gap-1 rounded-md px-1.5 py-1 text-sm font-medium leading-5 tracking-[-0.15px] text-brand-neutral-950">
        <span className={`h-[7px] w-[7px] rounded-full ${statusMeta.dotClassName}`} aria-hidden="true" />
        {statusMeta.label}
      </span>
    </div>
  )
}
